import * as React from 'react';
import { useState, useContext } from "react";
import { useLocation } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import FormControl from '@mui/material/FormControl';
import NativeSelect from '@mui/material/NativeSelect';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faPlus, faArrowLeft, faShareAlt, faEdit, faTrash, faTimes, faCheck } from '@fortawesome/free-solid-svg-icons';
import AuthContext from "../AuthContext";
import { logout } from "./Login/auth";
import { Link as RouterLink } from "react-router-dom";
import RecipeBookContext from './RecipeBook/RecipeBookContext';
import './RecipeBook/RecipeBook.css';
import './Header.css';

export default function Header() {

    const { user } = useContext(AuthContext);
    const location = useLocation();
    const isRecipesPage = location.pathname.startsWith('/recipes');
    const rb = useContext(RecipeBookContext);
  const navItems = [
    { label: 'Shopping', to: '/shopping' },
    { label: 'Vault', to: '/vault' },
    { label: 'Vault Management', to: '/vault-management' },
    { label: 'Users', to: '/users' },
    { label: 'Recipe Books', to: '/recipes' },
    { label: 'Nura Import', to: '/nura-import' },
    { label: 'Settings', to: '/settings' },
  ];

    const [state, setState] = React.useState({
        left: false
    });

    const toggleDrawer = (anchor, open) => (event) => {
        if (
          event &&
          event.type === 'keydown' &&
          (event.key === 'Tab' || event.key === 'Shift')
        ) {
          return;
        }
    
        setState({ ...state, [anchor]: open });
      };

      const list = (anchor) => (
        <Box
          sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}
          role="presentation"
          onClick={toggleDrawer(anchor, false)}
          onKeyDown={toggleDrawer(anchor, false)}
        >
          <List>
            {navItems.map((item) => (
              <ListItem key={item.to} disablePadding>
                <ListItemButton component={RouterLink} to={item.to}>
                  <ListItemText primary={item.label} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
          <Divider />
          <List>
            <ListItem disablePadding>
              <ListItemButton onClick={() => { logout(); toggleDrawer(anchor, false)(); }}>
                <ListItemText primary="Logout" sx={{ color: '#f44336' }} />
              </ListItemButton>
            </ListItem>
          </List>
        </Box>
      );

    if (!user) {
        return;
    }

    return (
        <AppBar position="sticky" sx={{ top: 0, zIndex: 1200 }}>
          <Toolbar className='toolbar'>
            {/* Back button when viewing recipe detail */}
            {isRecipesPage && rb.currentView === 'recipe' && (rb.viewingRecipe || rb.editingRecipe) ? (
              <IconButton
                size="small"
                edge="start"
                color="inherit"
                aria-label="back"
                sx={{ mr: 0.5 }}
                onClick={() => rb.editingRecipe ? rb.cancelEditRecipe() : rb.closeRecipeDetail()}
              >
                <FontAwesomeIcon icon={faArrowLeft} style={{ fontSize: 14 }} />
              </IconButton>
            ) : (
              <IconButton
                size="small"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ mr: 0.5 }}
                onClick={toggleDrawer('left', true)}
              >
                <MenuIcon fontSize="small" />
              </IconButton>
            )}

            {/* Recipe detail: book dropdown + action buttons on the left */}
            {isRecipesPage && rb.currentView === 'recipe' && (rb.viewingRecipe || rb.editingRecipe) && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 0.25, sm: 0.5 }, mr: 1 }}>
                <FormControl size="small" sx={{ minWidth: { xs: 48, sm: 90 }, height: { xs: 32, sm: undefined }, minHeight: { xs: 32, sm: undefined }, flexShrink: 1 }} className="header-book-select">
                  <NativeSelect
                    value={rb.selectedBookId}
                    onChange={(e) => rb.selectBook(e.target.value)}
                    inputProps={{ 'aria-label': 'Select book' }}
                  >
                    {rb.books.map((book) => (
                      <option key={book.id} value={book.id} style={{ color: '#000', background: '#fff' }}>{book.name}{!book.is_owner ? ' (shared)' : ''}</option>
                    ))}
                    <option value="__all_books__" style={{ color: '#000', background: '#fff' }}>📚 All Books</option>
                    <option value="__new__" style={{ color: '#000', background: '#fff' }}>＋ Create New Book...</option>
                  </NativeSelect>
                </FormControl>
                {rb.viewingRecipe && rb.canEditRecipe && !rb.showAddRecipeModal && (
                  <>
                    <button className="header-rk-search-toggle" onClick={() => rb.shareRecipeLink()} title="Share Link">
                      <FontAwesomeIcon icon={faShareAlt} />
                    </button>
                    <button className="header-rk-search-toggle" onClick={() => rb.openEditRecipe(rb.viewingRecipe)} title="Edit">
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                    <button className="header-rk-add-btn" style={{ background: '#f44336' }} onClick={() => rb.deleteRecipe(rb.viewingRecipe)} title="Delete">
                      <FontAwesomeIcon icon={faTrash} />
                    </button>
                  </>
                )}
              </Box>
            )}

            {/* The Typography component applies 
             default font weights and sizes */}
    
            <Typography variant="h6" 
              component="div" sx={{ flexGrow: 1, fontSize: isRecipesPage && rb.currentView === 'recipe' ? '0.85rem' : undefined, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 'calc(100% - 200px)' }}>
              {isRecipesPage ? 'Recipe Books' : 'Home'}
            </Typography>

            {/* Book dropdown + search/add (when NOT viewing a recipe) */}
            {isRecipesPage && !rb.isLoading && rb.books.length > 0 && rb.currentView !== 'recipe' && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 0.25, sm: 1 } }}>
                <FormControl size="small" sx={{ minWidth: { xs: 48, sm: 120, md: 180 }, height: { xs: 32, sm: undefined }, minHeight: { xs: 32, sm: undefined }, flexShrink: 1 }} className="header-book-select">
                  <NativeSelect
                    value={rb.selectedBookId}
                    onChange={(e) => rb.selectBook(e.target.value)}
                    inputProps={{ 'aria-label': 'Select book' }}
                  >
                    {rb.books.map((book) => (
                      <option key={book.id} value={book.id} style={{ color: '#000', background: '#fff' }}>{book.name}{!book.is_owner ? ' (shared)' : ''}</option>
                    ))}
                    <option value="__all_books__" style={{ color: '#000', background: '#fff' }}>📚 All Books</option>
                    <option value="__new__" style={{ color: '#000', background: '#fff' }}>＋ Create New Book...</option>
                  </NativeSelect>
                </FormControl>
                <button className="header-rk-search-toggle" onClick={() => rb.setShowSearchBar && rb.setShowSearchBar(true)}>
                  <FontAwesomeIcon icon={faSearch} />
                </button>
                <button className="header-rk-add-btn" onClick={() => rb.setShowAddMenu(true)}>
                  <FontAwesomeIcon icon={faPlus} />
                </button>
              </Box>
            )}

            <SwipeableDrawer
                anchor={'left'}
                open={state['left']}
                onClose={toggleDrawer('left', false)}
                onOpen={toggleDrawer('left', true)}
            >
            {list('left')}
            </SwipeableDrawer>
          </Toolbar>
        </AppBar>
    );
  }